import React from 'react';

export const Choice: React.FC<React.SVGProps<SVGSVGElement>> = ({ width, height, color }) => (
    <svg width={width || '1em'} height={height || '1em'} viewBox="0 0 1664 1536">
        <path fill={color || 'currentColor'} d="m160,1408h608V256H128v1120c0,8.67,3.17,16.17,9.5,22.5s13.83,9.5,22.5,9.5Zm1376-32V256h-640v1152h608c8.67,0,16.17-3.17,22.5-9.5s9.5-13.83,9.5-22.5Zm128-1216v1216c0,44-15.67,81.67-47,113s-69,47-113,47H160c-44,0-81.67-15.67-113-47-31.33-31.33-47-69-47-113V160c0-44,15.67-81.67,47-113C78.33,15.67,116,0,160,0h1344c44,0,81.67,15.67,113,47s47,69,47,113Z" />
    </svg>
);
